import * as React from "react";
const CloverIcon = () => (
  <svg
    width={164}
    height={40}
    viewBox="0 0 164 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15047_3797)">
      <path
        d="M67.3606 27.0821C64.2221 30.7768 60.5773 32.2449 56.8821 32.2449C49.8964 32.2449 44.3281 27.2335 44.3281 20.653C44.3281 14.123 49.6434 9.06104 56.6289 9.06104C60.3243 9.06104 63.9688 10.5291 67.1073 14.2242L62.4502 17.5145C60.7798 15.1356 58.8562 14.1736 56.6289 14.1736C53.0349 14.1736 50.0988 17.0591 50.0988 20.653C50.0988 24.2974 53.2879 27.1323 56.8821 27.1323C59.1092 27.1323 61.0836 26.1711 62.8047 23.9938L67.3606 27.0821Z"
        fill="black"
      />
      <path d="M69.9395 0H75.761V31.79H69.9395V0Z" fill="black" />
      <path
        d="M91.1491 9.06104C98.1346 9.06104 103.703 14.123 103.703 20.653C103.703 27.1833 98.1346 32.2449 91.1491 32.2449C84.1638 32.2449 78.5449 27.1833 78.5449 20.653C78.5449 14.123 84.1638 9.06104 91.1491 9.06104ZM91.1491 27.3347C94.7937 27.3347 98.1346 24.3987 98.1346 20.653C98.1346 16.9073 94.7937 13.9712 91.1491 13.9712C87.454 13.9712 84.1638 16.9073 84.1638 20.653C84.1638 24.3987 87.454 27.3347 91.1491 27.3347Z"
        fill="black"
      />
      <path
        d="M102.779 9.5166H109.613L115.131 21.4127L121.104 9.5166H127.432L115.131 33.1567L102.779 9.5166Z"
        fill="black"
      />
      <path
        d="M147.622 29.2586C145.394 31.1315 142.307 32.2449 139.067 32.2449C132.082 32.2449 126.463 27.1833 126.463 20.653C126.463 14.123 131.575 9.06104 138.561 9.06104C145.547 9.06104 150.102 14.123 150.102 20.653V22.3235H132.284C133.094 25.2594 135.929 27.3347 139.067 27.3347C140.991 27.3347 142.661 26.7274 144.18 25.1582L147.622 29.2586ZM143.977 17.5652C143.117 15.5405 141.193 13.9712 138.561 13.9712C135.98 13.9712 133.853 15.3886 132.79 17.5652H143.977Z"
        fill="black"
      />
      <path
        d="M152.957 19.2863C152.957 13.9713 157.006 9.5166 163.587 9.5166V14.7304C160.752 14.7304 158.728 16.4519 158.728 19.9953V31.7899H152.957V19.2863Z"
        fill="black"
      />
      <path
        d="M18.0257 10.4333C18.0257 5.45921 13.9886 1.42041 9.0109 1.42041C4.0344 1.42041 0 5.45407 0 10.4281C0 15.4022 4.03433 19.4461 9.01315 19.4461H18.0256L18.0257 10.4333Z"
        fill="black"
      />
      <path
        d="M20.5547 10.4333C20.5547 5.45921 24.5918 1.42041 29.5695 1.42041C34.546 1.42041 38.5804 5.45407 38.5804 10.4281C38.5804 15.4022 34.546 19.4461 29.5672 19.4461L20.5547 19.4461L20.5547 10.4333Z"
        fill="black"
      />
      <path
        d="M20.5547 30.9875C20.5547 35.9664 24.5907 40.0003 29.5703 40.0003C34.5444 40.0003 38.5804 35.9694 38.5804 30.9904C38.5804 26.0162 34.5445 21.9746 29.5672 21.9746L20.5547 21.9746V30.9875Z"
        fill="black"
      />
      <path
        d="M18.0257 30.9875C18.0257 35.9664 13.9897 40.0003 9.01013 40.0003C4.03601 40.0003 0 35.9694 0 30.9904C0 26.0162 4.03593 21.9746 9.01319 21.9746H18.0257V30.9875ZM9.01013 37.4588C12.5872 37.4588 15.4974 34.5572 15.4974 30.9904V24.5043H9.01836C5.4397 24.5043 2.52802 27.4252 2.52802 30.9904C2.52802 34.5572 5.43577 37.4588 9.01013 37.4588Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_15047_3797">
        <rect width={164} height={40} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CloverIcon;
